import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { REMEDY_UPLOAD } from 'AppSrc/core/components/forms/form-types/create-crq/section-five/work-information-items/work-information-item-constants';
import { InlineErrors } from './sub-components/inline-errors';
import { FieldTitle } from './sub-components/field-title';
import { FieldSubTitle } from './sub-components/field-sub-title';
import { CharacterLimit } from './sub-components/character-limit';
import { TipModal } from './sub-components/tip-modal';
import {
  vFParamsPropShape,
  disabledFieldOptionsShape,
} from './data-structure/v-f-proptypes';
import {
  getFieldPropShape,
  formPropShape,
} from './data-structure/formik-proptypes';
import 'AppSrc/core/style/components/form/form-base-components/v-f-textarea.css';

const getDisplayHeightClassName = (characterLimit) => {
  if (characterLimit === undefined) {
    return 'textarea-full-height';
  }
  const heightClassName = characterLimit <= 100 ? 'textarea-min-height' : 'textarea-full-height';
  return heightClassName;
};

class VFTextarea extends PureComponent {
  constructor(props) {
    super(props);
    this.updateValue = this.updateValue.bind(this);
    this.setTouched = this.setTouched.bind(this);
  }

  componentDidMount() {
    this.ifDisabledSetDefaultValues({});
  }

  componentDidUpdate(prevProps) {
    this.ifDisabledSetDefaultValues({
      prevProps,
    });
  }

  setTouched() {
    const {
      field,
    } = this.props;

    const {
      name,
    } = field;

    this.props.form.setFieldTouched(name, true);
  }

  updateValue(e) {
    const {
      field,
    } = this.props;

    const {
      name,
    } = field;

    const value = e.target.value;

    this.props.form.setFieldValue(name, value);

    return null;
  }

  ifDisabledSetDefaultValues(params) {
    const {
      prevProps,
    } = params;
    const {
      name,
      value,
    } = this.props.field;
    const {
      disabled,
      disabledValue,
      unDisabledValue,
    } = this.props.disabledFieldOptions;
    // check if the previous props had set it to disabled
    const prevDisabled = prevProps ? prevProps.disabledFieldOptions.disabled : false;

    if (!disabled) {
      if (prevDisabled) {
        this.props.form.setFieldValue(name, unDisabledValue);
        this.props.form.setFieldTouched(name, true);
      }
      return null;
    }



    if (JSON.stringify(value) !== JSON.stringify(disabledValue)) {
      this.props.form.setFieldValue(name, disabledValue);
      this.props.form.setFieldTouched(name, true);
    }
    return null;
  }

  render() {

    const {
      vFParams,
      field,
      form,
      disabledFieldOptions,
      optional,
    } = this.props;

    const {
      name,
      // value,
    } = field;
    let {
      value,
    } = field;
    if (name === 'summary') {
      value = value.replace(REMEDY_UPLOAD, '');
    }
    const {
      disabled,
    } = disabledFieldOptions;

    const formErrors = form.errors;
    const touched = form.touched[name];


    const errors = formErrors[name];

    const inlineErrors = errors && errors.inlineErrors ? errors.inlineErrors : null;

    const {
      fieldTitle,
      fieldSubTitle,
      placeholder,
      characterLimit,
      tip,
    } = vFParams;

    const className = `v-f-field-type v-f-textarea${disabled ? ' v-f-textarea-disabled' : ''} v-f-textarea-${name}`;

    return (
      <div
        className={className}
        name={name}
      >
        {
          fieldTitle && (
            <FieldTitle
              fieldTitle={fieldTitle}
              optional={optional}
            />
          )
        }
        {
          fieldSubTitle && (
            <FieldSubTitle
              fieldSubTitle={fieldSubTitle}
            />
          )
        }
        <textarea
          value={value}
          className={getDisplayHeightClassName(characterLimit)}
          onChange={this.updateValue}
          placeholder={placeholder}
          onBlur={this.setTouched}
        />
        {
          characterLimit && (
            <CharacterLimit
              value={value}
              characterLimit={characterLimit}
            />
          )
        }
        {
          inlineErrors && touched && (
            <InlineErrors
              inlineErrors={inlineErrors}
            />
          )
        }
        {
          tip && (
            <TipModal
              tip={tip}
              name={name}
            />
          )
        }
      </div>
    );
  }
}

VFTextarea.propTypes = {
  vFParams: vFParamsPropShape,
  // we have to define the value within the data structure for field
  field: getFieldPropShape(PropTypes.string),
  form: formPropShape,
  disabledFieldOptions: disabledFieldOptionsShape,
  optional: PropTypes.bool,
};

const noValueVFTextarea = (value) => {
  if (value === null) {
    return true;
  }

  return value.trim().length < 1;
};


// This is a reference to the component. This is needed as the value for each form field is displayed on a change summary
// page but this is dependant on what type of form field is used
const VF_TEXTAREA = 'v-f-textarea';

export {
  VFTextarea,
  noValueVFTextarea,
  VF_TEXTAREA,
};
